import SingleFilter from 'components/FilterPopover/SingleFilter';
import AppStoreContext from 'contexts/AppStoreContext';
import React, { useContext } from 'react';
import { RFIQuery } from 'records/RFIQuery';
import { useTranslator } from '@bluebeam/react-i18n';

interface Props {
  rfiTableQuery: RFIQuery;
  updateRFIQuery: (nextRFIQuery: RFIQuery) => void;
}

const ClosedItemsCheckbox: React.FC<Props> = (props: Props) => {
  const { rfiTableQuery, updateRFIQuery } = props;
  const { state: appState } = useContext(AppStoreContext);
  const { rfis } = appState;
  const { translate } = useTranslator(['filters']);

  /* Handlers */
  function onCheckboxChange(isChecked: boolean) {
    const nextRFIQuery = rfiTableQuery.set('closed', isChecked);

    updateRFIQuery(nextRFIQuery);
  }

  // disable if no rfis, or if all are closed.
  const disabled = rfis.size === 0 || rfis.every((rfi) => rfi.answer === null);

  return (
    <SingleFilter
      checked={rfiTableQuery.closed}
      text={translate('filters:closedItems')}
      onChange={onCheckboxChange}
      disabled={disabled}
    />
  );
};

export default ClosedItemsCheckbox;
